// Инструкция по установке сертификатов Минцифры.
// Ведём на Госуслуги, а не на сайт банка: у пользователя, который видит это
// сообщение, сайт банка как раз и не открывается.
export const MINDIGITAL_CERTIFICATES_URL = 'https://www.gosuslugi.ru/crt';

export default MINDIGITAL_CERTIFICATES_URL;
